<template>
    <div>
        <h5 class="mb-4">
            <strong>Gestión de ediciones</strong>
        </h5>

        <b-row class="mb-3">
            <b-col md="3">
                <b-form-group label="Fecha de publicación">
                    <el-date-picker v-model="selectedDates" type="daterange" range-separator="|"
                        start-placeholder="Fecha inicio" end-placeholder="Fecha fin" size="medium" :clearable="true"
                        style="width: 100%" class="form-control" :picker-options="pickerOptions" />
                </b-form-group>
            </b-col>

            <b-col md="3">
                <b-form-group label="Edición">
                    <b-form-input v-model="filterVersionsSga.version" type="text" placeholder="Buscar por edición"
                        class="form-control" />
                </b-form-group>
            </b-col>

            <b-col md="3">
                <b-form-group label="Estado">
                    <el-select v-model="filterVersionsSga.is_active" clearable filterable size="medium"
                        placeholder="Buscar por estado">
                        <el-option v-for="item in statesSga" :key="item.id" :label="item.name" :value="item.id" />
                    </el-select>
                </b-form-group>
            </b-col>

            <b-col md="3" class="mt-auto">
                <b-form-group>
                    <b-button variant="primary" @click="searchVersionsSga">
                        <i class="fa fa-search"></i>
                        <span class="ml-1" v-text="'Buscar'"></span>
                    </b-button>
                    <b-button class="mx-1" @click="clearFilter">
                        <i class="fa fa-eraser"></i>
                        <span class="ml-1" v-text="'Limpiar'"></span>
                    </b-button>
                </b-form-group>
            </b-col>

            <!-- <b-col md="12" class="mt-4 d-flex justify-content-end align-items-center">
                <b-form-group>
                    <b-button variant="primary" @click="createVersion">
                        <i class="fa fa-plus" />
                        <span class="ml-1" v-text="'Nueva Edición'" />
                    </b-button>
                </b-form-group>
            </b-col> -->

            <b-modal id="modal_create_versions" size="lg  " hide-footer no-close-on-esc no-close-on-backdrop
                hide-header-close>
                <template #modal-title>
                    {{ action === 'edit' ? 'Editar' : 'Registrar nueva' }} edición
                </template>
                <formVersions />
            </b-modal>

            <b-col md="12">
                <b-form-group>
                    <b-table :items="versionsSga.data" :fields="fields" responsive striped hover bordered
                        thead-tr-class="table-active" show-empty thead-class="table-active"
                        empty-text="No hay resultados para mostrar.">
                        <template #cell(version)="data">
                            <div class="d-flex align-items-center justify-content-center">
                                <el-tooltip v-if="data.item.is_main === 1" content="Esta es la edición marcada como principal en el sistema" placement="top" effect="light">
                                    <i class="fa fa-check-circle text-success mr-2" style="font-size: 14px;"></i>
                                </el-tooltip>
                                <span v-text="data.item.version"></span>
                                <span v-if="(data.item.sga_version_slq_country && data.item.sga_version_slq_country.length > 0)" class="ml-1">
                                    - {{ data.item.sga_version_slq_country[0].name }}
                                </span>
                            </div>
                        </template>
                        <template #cell(is_active)="data">
                            <b-badge :variant="data.item.is_active ? 'success' : 'danger'"
                                v-text="data.item.is_active ? 'ACTIVO' : 'INACTIVO'" />
                        </template>
                        <template #cell(is_being_replicated)="data">
                            <template v-if="data.item.is_being_replicated === 1">
                                <b-badge
                                    variant="warning"
                                    v-text="'En Proceso'" />
                            </template>
                            <template v-else-if="data.item.count_replicated > 0">
                                <b-badge variant="success" v-text="'Completada'" />
                            </template>
                            <template v-else>
                                <b-badge variant="secondary" v-text="'Sin replicación'" />
                            </template>
                        </template>
                        <template #cell(actions)="data">
                            <div class="d-flex justify-content-lg-center justify-content-between flex-wrap flex-nowrap">
                                 <!-- Botón de bloqueo/desbloqueo -->
                                <el-tooltip v-if="canManageLock"
                                            :content="data.item.is_locked ? 'Desbloquear' : 'Bloquear'"
                                            placement="top"
                                            effect="light">
                                    <el-button type="text"
                                            :class="data.item.is_locked ? 'text-success' : 'text-warning'"
                                            @click="toggleLock(data.item)"
                                            :disabled="data.item.is_being_replicated === 1">
                                        <i :class="`fa ${data.item.is_locked ? 'fa fa-lock' : 'fa fa-unlock-alt'} fa-lg`"></i>
                                    </el-button>
                                </el-tooltip>
                                <el-tooltip content="Editar" placement="top" effect="light">
                                    <el-button type="text" class="text-primary" @click="editVersion(data.item)">
                                        <i class="fa fa-edit fa-lg"></i>
                                    </el-button>
                                </el-tooltip>
                                <el-tooltip class="ml-2" :content="data.item.is_active ? 'Inactivar' : 'Activar'"
                                    placement="top" effect="light">
                                    <el-button type="text" @click="changeStatus(data.item.id)"
                                        :class="`${!data.item.is_active ? 'text-success' : 'text-danger'}`">
                                        <i :class="`fa fa-lg ${!data.item.is_active ? 'fa-check' : 'fa-close'}`"></i>
                                    </el-button>
                                </el-tooltip>
                                <el-tooltip class="ml-2" content="Duplicar Edición" placement="top" effect="light">
                                    <el-button type="text" @click="onHandleOpenViewToDuplicateVersiones(data.item)">
                                        <i class="fa fa-clone"></i>
                                    </el-button>
                                </el-tooltip>
                            </div>
                        </template>
                    </b-table>
                </b-form-group>
            </b-col>

            <b-col md="12">
                <b-form-group>
                    <div class="d-flex justify-content-end align-items-center pr-4">
                        <el-pagination style="max-width: 100%" v-model="filterVersionsSga.page"
                            :total="filterVersionsSga.total" :current-page="filterVersionsSga.page"
                            :page-size="filterVersionsSga.per_page" @size-change="afterChangeSizePagination"
                            @current-change="afterChangePagePagination" :page-sizes="[10, 30, 50, 100]"
                            layout="total, sizes, prev, pager, next" />
                    </div>
                </b-form-group>
            </b-col>

        </b-row>

    </div>
</template>
<script>
import { mapActions, mapState, mapMutations } from 'vuex';
import formVersions from './FormVersions.vue';
import { validarPermisoComponente } from '@/plugins/acl';
export default {
    name: 'Versions',
    components: {
        formVersions,
    },
    data() {
        return {
            selectedDates: [],
            pickerOptions: {
                disabledDate(time) {
                    const today = new Date();
                    today.setHours(0, 0, 0, 0);
                    return time.getTime() >= today.setDate(today.getDate() + 1);
                },
            },
            fields: [
                {
                    key: "version",
                    label: "Edición",
                    sortable: true,
                    tdClass: "text-center",
                    thClass: "text-center",
                },
                {
                    key: "date_of_publication",
                    label: "Fecha de publicación",
                    sortable: true,
                    tdClass: "text-center",
                    thClass: "text-center",
                },
                {
                    key: "is_active",
                    label: "Estado",
                    tdClass: "text-center",
                    thClass: "text-center",
                },
                {
                    key: "user.name",
                    label: "Creado por",
                    tdClass: "text-center",
                    thClass: "text-center",
                },
                {
                    key: "is_being_replicated",
                    label: "Replicación",
                    tdClass: "text-center",
                    thClass: "text-center",
                },
                {
                    key: "actions",
                    label: "Acciones",
                    sortable: false,
                    tdClass: "text-center",
                    thClass: "text-center",
                },
            ],
        };
    },

    watch: {
        selectedDates(newValue) {
            if (Array.isArray(newValue) && newValue.length === 2) {
                this.setDateOfPublicationSga(newValue)
            }
        },
    },

    computed: {
        ...mapState('sgaVersions', ['versionsSga', 'action', 'statesSga', 'filterVersionsSga']),
        canManageLock() {
            return validarPermisoComponente('gestionar-configuracion-sga');
        }
    },

    methods: {

        ...mapActions('sgaVersions', ['getVersionsSga', 'getActiveVersionsSga', 'changeStatusVersionSga', 'showVersionSga', 'toggleLockVersionSga']),

        ...mapMutations('sgaVersions', ['setActionSga', 'setDefaultFilterSgaVersions', 'loadAfterChangeSizePagination',
            'loadAfterChangePagePagination', 'setVersionSga', 'setDateOfPublicationSga']),
        ...mapMutations('sgaConfigsDuplicateVersions', [
            'setIsShowingHomeDuplicateVersions',
            'resetNewVersion',
            'setNewVersion'
        ]),

        createVersion() {
            this.setActionSga('create');
            this.$bvModal.show('modal_create_versions');
        },

        async clearFilter() {
            this.selectedDates = [];
            this.setDefaultFilterSgaVersions();
            await this.getVersionsSga();
        },

        async afterChangeSizePagination(size) {
            this.loadAfterChangeSizePagination(size);
            await this.getVersionsSga();
        },

        async afterChangePagePagination(page) {
            this.loadAfterChangePagePagination(page);
            await this.getVersionsSga();
        },

        async changeStatus(id) {
            await this.changeStatusVersionSga(id);
            await this.getVersionsSga();
            await this.getActiveVersionsSga();
        },

        editVersion(version) {
            this.showVersionSga(version.id);
            this.setActionSga('edit');
            this.$bvModal.show('modal_create_versions');
        },

        async searchVersionsSga() {
            await this.getVersionsSga(true);
        },

        onHandleOpenViewToDuplicateVersiones(versionToDuplicate) {
            this.resetNewVersion();

            let subNotDangersIds = []
            if (versionToDuplicate.sga_sub_not_danger_versions && typeof versionToDuplicate.sga_sub_not_danger_versions === 'object' && versionToDuplicate.sga_sub_not_danger_versions.length > 0) {
                subNotDangersIds = versionToDuplicate.sga_sub_not_danger_versions.map(x => x.id)
            }

            let countriesIds = []
            if (versionToDuplicate.sga_version_slq_country && typeof versionToDuplicate.sga_version_slq_country === 'object' && versionToDuplicate.sga_version_slq_country.length > 0) {
                countriesIds = versionToDuplicate.sga_version_slq_country.map(x => x.id)
            }

            this.setNewVersion({
                version: null,
                date_of_publication: versionToDuplicate.date_of_publication,
                version_to_duplicate: versionToDuplicate.id,
                subs_not_dangers: subNotDangersIds,
                countries: countriesIds,
                is_main: versionToDuplicate.is_main
            })

            this.setIsShowingHomeDuplicateVersions(true);
        },
        async toggleLock(version) {
            const action = version.is_locked ? 'desbloquear' : 'bloquear';

            this.$alertConfirmation({
                icon: 'warning',
                title: 'Confirmación',
                text: `¿Está seguro que desea ${action} la edición ${version.version}?`,
                showConfirmButton: true,
                showCancelButton: true,
                titleBtnConfirm: 'Sí, continuar',
                titleBtnCancel: 'Cancelar',
                onConfirm: async () => {
                    const success = await this.toggleLockVersionSga(version.id);
                    if (success) {
                        await this.getVersionsSga();
                    }
                }
            });
        }
    },
};
</script>
